export const NOT_FOUND_ROUTE = {
  name: 'not-found',
  path: '/not-found',
} as const

export const LOGIN_ROUTE = {
  name: 'user',
  path: '/user',
} as const

export const REDIRECT_ROUTE = {
  name: 'redirect',
  path: '/redirect',
} as const

export const DEFAULT_ROUTE = {
  title: 'menu.dashboard',
  name: '(public).dashboard',
  path: '/dashboard',
} as const

// 兜底主页（无 redirect 时回退）
export const DEFAULT_ROUTE_PATH = '/'

export const DEFAULT_META = {
  requiresAuth: true,
  renderMenu: true,
  order: 99,
}
